<template>
  <div id="contacts-section" class="g-bg-black-opacity-0_9 g-color-white-opacity-0_8 g-py-60">
    <div class="container">
      <div class="row">
        <!-- Footer Content -->
        <div class="col-lg-4 col-md-6 g-mb-40 g-mb-0--lg">
          <div class="u-heading-v2-3--bottom g-brd-white-opacity-0_8 g-mb-20">
            <h2 class="u-heading-v2__title h6 text-uppercase mb-0">關於我們</h2>
          </div>

          <p>
            【智】慧平台<br />
            跨境【郵】遞<br />
            【易】如反掌<br />
            <br />
            【智郵易】提供一站式自助跨境郵包投寄服務，為您將郵包
            直送不同國家或地區。
          </p></div>
        <!-- End Footer Content -->

        <!-- Footer Content -->
        <div class="col-lg-4 col-md-6 g-mb-40 g-mb-0--lg">
          <div class="u-heading-v2-3--bottom g-brd-white-opacity-0_8 g-mb-20">
            <h2 class="u-heading-v2__title h6 text-uppercase mb-0">目錄</h2>
          </div>

          <nav class="text-uppercase1">
            <ul class="list-unstyled g-mt-minus-10 mb-0">
              <li class="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/">關於智郵易</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/process">寄件流程</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/about">出口路線</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/tracking">物流追蹤</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/post-office">智郵易投遞網點</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-brd-bottom g-brd-white-opacity-0_1 g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/faq">常見問題</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/terms">基本條款</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
              <li class="g-pos-rel g-py-10">
                <h4 class="h6 g-pr-20 mb-0">
                  <router-link class="g-color-white-opacity-0_8 g-color-white--hover" to="/privacy">私隱政策</router-link>
                  <i class="fa fa-angle-right g-absolute-centered--y g-right-0"></i>
                </h4>
              </li>
            </ul>
          </nav>
        </div>
        <!-- End Footer Content -->

        <!-- Footer Content -->
        <div class="col-lg-4 col-md-6">
          <div class="u-heading-v2-3--bottom g-brd-white-opacity-0_8 g-mb-20">
            <h2 class="u-heading-v2__title h6 text-uppercase mb-0">Our Contacts</h2>
          </div>

          <address class="g-bg-no-repeat g-font-size-12 mb-0" style="background-image: url(../../assets/img/maps/map2.png);">
            <!-- Location -->
            <div class="d-flex g-mb-20">
              <div class="g-mr-10">
              <span class="u-icon-v3 u-icon-size--xs g-bg-white-opacity-0_1 g-color-white-opacity-0_6">
                <i class="fa fa-map-marker"></i>
              </span>
              </div>
              <p class="mb-0">Unit C & D, 1/F, Blk 2, Kwai Tak Industrial Centre, No 15-33 Kwai Tak Street, Kwai Chung NT HK</p>
            </div>
            <!-- End Location -->

            <!-- Phone -->
            <div class="d-flex g-mb-20">
              <div class="g-mr-10">
              <span class="u-icon-v3 u-icon-size--xs g-bg-white-opacity-0_1 g-color-white-opacity-0_6">
                <i class="fa fa-phone"></i>
              </span>
              </div>
              <p class="mb-0">(+852) 2275 1314</p>
            </div>
            <!-- End Phone -->
          </address>
        </div>
        <!-- End Footer Content -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  mounted() {

  },
  computed: {},
};
</script>

<style lang="scss">

</style>
